// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonCol, IonContent, IonGrid, IonRow, IonText } from "@ionic/react"
import { useLocales } from "react-localized"
import SectionContent from "./SectionContent"
import SectionPageHeader from "./SectionPageHeader"
import useScreenSize from "./useScreenSize"
import useWindowDimensions from "./useWindowDimensions"


const UnsupportedDevice: React.FC = () => {
  const {height} = useWindowDimensions()
  const {gettext} = useLocales()
  const contentHeight = `calc(${height}px - var(--offset-top) - var(--offset-bottom) - var(--page-header-height))`
  const isFullScreen = useScreenSize()
  const containerStyle = {
    "--panel-padding": (!!isFullScreen) ? "24px" : "11px",
    "--section-header-height": "48px",
    "--section-content-height": contentHeight,
    "--section-padding": (!!isFullScreen) ? "24px" : "11px",
    height: contentHeight,
  }
  return (
    <IonContent fullscreen scrollY={false}>
      <div className="section-container" style={containerStyle as React.CSSProperties}>
        <div className="section-content" style={{paddingTop: "0px"}}>
          <SectionPageHeader title={gettext("Device not supported")}></SectionPageHeader>
          <SectionContent>
            <IonGrid style={{paddingTop: "var(--section-padding)"}}>
              <IonRow className="panel">
                <IonCol>
                  <IonText>
                    <p style={{paddingRight: "11px"}}>{gettext("Unfortunately you can not use this application with your current device.")}</p>
                  </IonText>
                </IonCol>
              </IonRow>
            </IonGrid>
          </SectionContent>
        </div>
      </div>
    </IonContent>
  )
}


export { UnsupportedDevice }